import angular from 'angular';

import '../../../directives/file-data-model';
import '../../../services/lecturefiles';

angular.module('folkeuni').component('contractsUploadFiles', {
    templateUrl: '/shop-dist/templates/contracts-upload-files.html?c=' + window.cacheBurst,
    transclude: false,
    bindings: {
        contract: '=',
        user: '='
    },
    controller: function ($timeout, $scope, LectureFiles) {
        var $ctrl = this;
        $ctrl.comment = '';
        $ctrl.files = [
            // {
            //    name: fileName,
            //    path: filePath,
            //    fullPath: fullPath,
            //    size: file.size,
            //    type: file.type,
            //    loading: true,
            //    uploadedDate: null | string
            // }
        ];

        $scope.$watch('$ctrl.filepicker', function(files, oldVal) {
            //console.log('$ctrl.newVal:', files, '$ctrl.oldVal:', oldVal);
            if (files) {
                for (var index = 0; index < files.length; index++) {
                    var file = files[index]; 
                    uploadFile(file);
                }
            }
        });

        $ctrl.handleUploader = function(event) {
            event.target.parentNode.querySelector('[files-data-model]').click();
        }

        $ctrl.closeModal = function () {
            //$ctrl.contract = null;
            $ctrl.files = [];
            $ctrl.comment = '';
            $ctrl.loading = false;
        };

        $ctrl.removeFile = function (index) {
            $ctrl.files.splice(index, 1);
        };

        $ctrl.sendMaterial = function () {
            var anyUploading = $ctrl.files.some(function (file) {
                return file.loading;
            });
            if (anyUploading) {
                alert('Du skal afvente alle filerne er uploaded før du kan indsende');
                return;
            }
            if ($ctrl.files.length === 0) {
                alert('Du har ikke valgt nogle filer');
                return;
            }

            // Locks upload function until previous has been handled
            if ($ctrl.loading) {
                alert('Materialer er ved at blive behandlet, status følger..');
            } else {
                $ctrl.loading = true;

                var obj = {
                    files: $ctrl.files,
                    comment: $ctrl.comment,
                    contractId: $ctrl.contract.id
                };

                LectureFiles.sendMaterial(obj).then(function (res) {
                    $ctrl.loading = false;
                    alert('Der er sendt en mail til deltagerne med filerne');
                    $ctrl.closeModal();
                }, function (errorResponse) {
                    $ctrl.loading = false;
                    alert('Der er sket en fejl ved indsendelsen. Prøv igen senere eller kontakt os, hvis fejlen fortsætter');
                });
            }
        };

        $ctrl.$onInit = function () {
            $ctrl.loading = true;
            LectureFiles.getSasUrl().then(function (blobSas) {
                var blobSplit = blobSas.split('?');

                $ctrl.blobInfo = {
                    baseUrl: blobSplit[0] + "/",
                    query: "?" + blobSplit[1]
                };
                $ctrl.loading = false;
            }, function (errorResponse) {
                console.log(errorResponse);
                alert('Der er sket en fejl - prøv at opdatere siden og prøv igen');
            });
        };

        function uploadFile(file) {
            var fileName = file.name.toString();
            var newFileName = fileName.replace(/[^A-Z0-9., \-_æøå]/ig, "-");
            var filePath = getfilePath(newFileName);
            var fullPath = $ctrl.blobInfo.baseUrl + filePath;
            var uploadUrl = fullPath + $ctrl.blobInfo.query;            
            var fileInfo = {
                name: newFileName,
                path: filePath,
                fullPath: fullPath,
                size: file.size,
                type: file.type,
                loading: true
            };
            $ctrl.files.push(fileInfo);
            LectureFiles.uploadFileToBlob(uploadUrl, file).then(function (res) {
                var uploadedDate = res.headers('Date');
                fileInfo.loading = false;
                fileInfo.uploadedDate = uploadedDate;
            }, function (errorResponse) {
                console.log(errorResponse);
                var index = $ctrl.files.indexOf(fileInfo);
                if (index !== -1)
                    $ctrl.files.splice(index, 1);
                
                alert('Der er sket en fejl ved upload af filen: ' + file.name + '\nPrøv igen eller kontakt os, hvis fejlen fortsætter');
            });
        }

        function getfilePath(fileName) {
            var productId = $ctrl.contract.product.id;
            var employeeId = $ctrl.user.employee.id;

            var randomPart = makeid(6);
            return productId + "/" + employeeId + "/" + randomPart + "/" + fileName;
        }

        function makeid(length) {
            var result = [];
            var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
            }
            return result.join('');
        }
    }
});
